<template>
    <div class="approval_center_wrap" :class="isExpand ? 'expand_class' : ''">
        <div class="approval_center_tab" :class="isExpand ? 'expand_class' : ''" v-loading="approvalTypeListLoading">
            <template v-if="isExpand">
                <div class="retract_top">
                    <el-tooltip  effect="dark" content="搜索" placement="right">
                        <div class="custom_hover_active_class" @click="handleClickExpand">
                            <i class="iconfont icon-sousuoshaixuan"></i>
                        </div>
                    </el-tooltip>
                    <el-tooltip  effect="dark" :content="item.name" placement="right"  v-for="item in approval_tab_list">
                        <div class="custom_hover_active_class"  @click="handleClickApprovalTab(item);handleClickExpand()">
                            <i class="iconfont" :class="item.isExpand ? item.activeIcon : item.icon"></i>
                        </div>
                    </el-tooltip>

                </div>
                <div class="retract_bottom">
                    <div class="custom_hover_active_class" @click="handleClickExpand">
                        <i class="iconfont" :class="isExpand ? ' icon-zhankai' : 'icon-shouqi'"></i>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="approval_center_tab_search">
                    <el-input
                            v-model="searchForm.keyword"
                            placeholder="搜索您想要的内容"
                            size="small"
                            @keyup.enter.native="searchFilterChange"
                    >
                        <span slot="suffix" class="handle_icon_wrap">
                            <el-popover placement="right-start" width="500" trigger="click" @hide="searchFilterChange">
                                <div class="search_container">
                                    <div class="search_top_container">
                                        <span class="title">筛选</span>
                                        <el-button
                                                :disabled="
                                                searchFilterList.findIndex((find) => find.field_value) > -1
                                                    ? false
                                                    : true
                                            "
                                                size="mini"
                                                @click="handleClickReset"
                                        >清空筛选条件</el-button
                                        >
                                    </div>
                                    <div class="search_bottom_container">
                                        <ul>
                                            <li v-for="item in searchFilterList">
                                                <div>
                                                    <el-select size="small" v-model="item.field_key" disabled>
                                                        <el-option label="审批类型" value="approval_set_id"></el-option>
                                                        <el-option label="发起人" value="creator_uid"></el-option>
                                                    </el-select>
                                                </div>
                                                <div class="search_filter_type">
                                                    <el-select size="small" v-model="item.field_type" disabled>
                                                        <el-option label="满足" value="eq"></el-option>
                                                        <el-option label="不满足" value="neq"></el-option>
                                                    </el-select>
                                                </div>
                                                <div>
                                                    <template v-if="item.field_key == 'approval_set_id'">
                                                        <el-select
                                                                v-model="item.field_value"
                                                                clearable
                                                                collapse-tags
                                                                filterable
                                                                multiple
                                                                placeholder="请选择审批类型"
                                                                size="small"

                                                        >
                                                            <el-option
                                                                    v-for="type in approvalSetTypeList"
                                                                    :key="type.id"
                                                                    :label="type.name"
                                                                    :value="type.id"
                                                            ></el-option>
                                                        </el-select>
                                                    </template>
                                                    <template v-if="item.field_key == 'creator_uid'">
                                                        <el-select
                                                                v-model="item.field_value"
                                                                :remote-method="getUserList"
                                                                clearable
                                                                collapse-tags
                                                                filterable
                                                                multiple
                                                                placeholder="请选择发起人"
                                                                remote
                                                                size="small">
                                                            <el-option
                                                                    v-for="user in userList"
                                                                    :key="user.uid"
                                                                    :label="user.name"
                                                                    :value="user.uid"
                                                            >
                                                            </el-option>
                                                        </el-select>
                                                    </template>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <span slot="reference">
                                    <i class="iconfont icon-sousuoshaixuan"></i>
                                </span>
                            </el-popover>
                        </span>
                    </el-input>
                </div>
                <div class="approval_center_tab_list">
                    <ul>
                        <li v-for="item in approval_tab_list">
                            <div :class="{active: item.state == searchForm.processState,  child_active: item.state == searchForm.processState && searchForm.approval_set_id, }"
                                    class="top custom_hover_active_class font_bold"
                                    @click="handleClickApprovalTab(item)"
                            >
                                <i @click.stop="handleClickApprovalDropDown(item)" :class="{active : item.isPackUp}" class="iconfont el-icon-caret-right"></i>
                                <span v-if="item.state == 'awaiting_my_action'"
                                      :class="stateTypeNum.pending_num > 0 ? 'red_dot' : ''">
                                    <i class="iconfont" :class="item.isExpand ? item.activeIcon : item.icon"></i>
                                    {{ item.name }}
                                    {{ stateTypeNum.pending_num > 0 ? `(${stateTypeNum.pending_num})` : "" }}
                                </span>
                                <span v-else-if="item.state == 'received_by_me'"
                                      :class="stateTypeNum.received_num > 0 ? 'red_dot' : ''">
                                    <i class="iconfont " :class="item.isExpand ? item.activeIcon : item.icon"></i>
                                    {{ item.name }}
                                    {{ stateTypeNum.received_num > 0 ? `(${stateTypeNum.received_num})` : "" }}
                                </span>
                                <span v-else>
                                    <i class="iconfont" :class="item.isExpand ? item.activeIcon : item.icon"></i>
                                    {{ item.name }}
                                </span>
                            </div>
                            <div class="bottom">
                                <div class="at_make" v-if="item.isPackUp">
                                    <div class="at_make_list">
                                        <template v-for="atMake in item.at_make">
                                            <div
                                                    :class="{ active: atMake.state == searchForm.processState && searchForm.approval_set_id == '' }"
                                                    class="child_list_li custom_hover_active_class"
                                                    @click="handleClickApprovalTab(atMake)"
                                            >
                                                <i class="iconfont el-icon-caret-right"></i>
                                                <span>
                                                    <i
                                                            :class="atMake.isExpand ? atMake.activeIcon : atMake.icon"
                                                            class="iconfont"
                                                    ></i>
                                                    {{ atMake.name }}
                                                </span>
                                            </div>
                                            <div class="child_list child_list_li" v-if="atMake.isPackUp">
                                                <div
                                                        v-for="child in atMake.children"
                                                        class="child_list_li ellipsis custom_hover_active_class"
                                                        :class="{ active: searchForm.processState == atMake.state && searchForm.approval_set_id == child.approval_set_id, }"
                                                        @click="handleClickStateTypeItem(child, atMake)"
                                                >
                                                    <span v-text="child.approval_set_name"></span>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <div class="child_list" v-if="item.isPackUp">
                                    <div
                                            v-for="child in item.children"
                                            :class="{ active: searchForm.processState == item.state && searchForm.approval_set_id == child.approval_set_id, }"
                                            class="child_list_li ellipsis custom_hover_active_class"
                                            @click="handleClickStateTypeItem(child, item)">
                                        <span v-text="child.approval_set_name"></span>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="approval_center_tab_btn">
                    <div class="custom_hover_active_class" @click="handleClickExpand">
                        <i class="iconfont" :class="isExpand ? ' icon-zhankai' : 'icon-shouqi'"></i> 收起导航
                    </div>
                </div>
            </template>
        </div>
        <div class="approval_center_list" v-loading="approvalCenterLoading">
            <div class="approval_center_list_top">
                <div class="approval_center_list_top_left">
                    <el-dropdown
                            ref="updateDateCommand"
                            :hide-on-click="false"
                            placement="bottom-start"
                            trigger="click"
                            @command="handleDateCommand"
                    >
                        <span class="custom_hover_active_class approval_center_list_top_left_item ellipsis">
                            {{ searchForm.timeFilterText }}<i class="el-icon-arrow-down"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :class="{ active: searchForm.timeFilterText === '所有时间' }" command=""
                            >所有时间
                            </el-dropdown-item
                            >
                            <el-dropdown-item
                                    :class="{ active: searchForm.timeFilterText === '最近24小时' }"
                                    command="1"
                            >最近24小时
                            </el-dropdown-item
                            >
                            <el-dropdown-item :class="{ active: searchForm.timeFilterText === '最近7天' }" command="7"
                            >最近7天
                            </el-dropdown-item
                            >
                            <el-dropdown-item :class="{ active: searchForm.timeFilterText === '最近30天' }" command="30"
                            >最近30天
                            </el-dropdown-item
                            >
                            <el-popover placement="bottom" ref="customDatePopover" trigger="click" width="375">
                                <el-dropdown-item
                                        slot="reference"
                                        :class="{
                                        active:
                                            searchForm.timeFilterText !== '所有时间' &&
                                            searchForm.timeFilterText !== '最近24小时' &&
                                            searchForm.timeFilterText !== '最近7天' &&
                                            searchForm.timeFilterText !== '最近30天',
                                    }"
                                        command="custom"
                                >自定义时间范围
                                </el-dropdown-item
                                >
                                <el-date-picker
                                        v-model="searchForm.customDate"
                                        end-placeholder="结束日期"
                                        format="yyyy-MM-dd"
                                        range-separator="-"
                                        size="small"
                                        start-placeholder="开始日期"
                                        type="daterange"
                                        value-format="yyyy-MM-dd"
                                        @change="handleCustomDateChange"
                                >
                                </el-date-picker>
                            </el-popover>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-dropdown
                            ref="approveStatus"
                            :hide-on-click="false"
                            placement="bottom-start"
                            trigger="click"
                            @command="handleStatusCommand"
                    >
                        <span class="custom_hover_active_class approval_center_list_top_left_item ellipsis">
                            <span
                                    v-text="
                                    searchForm.approve_status === 0
                                        ? '审批中'
                                        : searchForm.approve_status === 1
                                        ? '已通过'
                                        : searchForm.approve_status === 2
                                        ? '已拒绝'
                                        : searchForm.approve_status === 3
                                        ? '已撤回'
                                        : '全部状态'
                                "
                            ></span>
                            <i class="el-icon-arrow-down"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="">全部状态</el-dropdown-item>
                            <el-dropdown-item :class="{ active: searchForm.approve_status === 0 }" :command="0"
                            >审批中
                            </el-dropdown-item
                            >
                            <el-dropdown-item
                                    v-show="searchForm.processState !== 'awaiting_my_action'"
                                    :class="{ active: searchForm.approve_status === 1 }"
                                    :command="1"
                            >已通过
                            </el-dropdown-item
                            >
                            <el-dropdown-item
                                    v-show="searchForm.processState !== 'awaiting_my_action'"
                                    :class="{ active: searchForm.approve_status === 2 }"
                                    :command="2"
                            >已拒绝
                            </el-dropdown-item
                            >
                            <el-dropdown-item
                                    v-show="searchForm.processState !== 'awaiting_my_action'"
                                    :class="{ active: searchForm.approve_status === 3 }"
                                    :command="3"
                            >已撤回
                            </el-dropdown-item
                            >
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div class="approval_center_list_top_right">
                    <el-tooltip
                            v-if="searchForm.processState == 'received_by_me'"
                            content="一键已读"
                            effect="dark"
                            placement="top"
                    >
                        <span
                                class="custom_hover_active_class approval_center_list_top_left_item"
                                @click="handleClickMarkAllAsReadSubmit"
                        >
                            <i class="drop"></i>
                            <i class="iconfont icon-youxiang"></i>
                        </span>
                    </el-tooltip>

                    <el-dropdown
                            ref="approveSort"
                            :hide-on-click="false"
                            placement="bottom-start"
                            trigger="click"
                            @command="handleSortCommand"
                    >
                        <el-tooltip content="排序" effect="dark" placement="top">
                            <span class="custom_hover_active_class approval_center_list_top_left_item">
                                <i class="iconfont icon-tuodong"></i>
                            </span>
                        </el-tooltip>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :class="{ active: searchForm.sort_field === 'desc' }" command="desc"
                            >按最新
                            </el-dropdown-item
                            >
                            <el-dropdown-item :class="{ active: searchForm.sort_field === 'asc' }" command="asc"
                            >按最久
                            </el-dropdown-item
                            >
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            <div class="approval_center_list_bottom">
                <ul v-infinite-scroll="loadApprovalList" :infinite-scroll-distance="20"
                    :infinite-scroll-immediate="false">
                    <li v-for="(item,key) in approvalList" :key="key" :class="{ active: approvalId == item.approval_id }" @click.stop="handleClickApproveItem(item)">
                        <div class="is_read" v-if="item.is_read == 0"><img src="https://download.hecoos.com/enlightv/2023-45/FM6wkxW3Fm4pw7TFxeGw.svg" alt="">
                        </div>
                        <div class="top">
                            <div class="approve_title">
                                <h5 class="ellipsis">{{ item.approval_set_name }}</h5>
                                <span :class="'approval_status_' + item.approval_status">{{getApprovalStatusText(item.approval_status)}}</span>
                            </div>
                            <div class="approve_user_time" @click.stop>
                                <userDetailPopover v-if="item.creator_info" :uid="item.creator_info.id">
                                    <div slot="container">
                                        <div class="user_info ellipsis">
                                            <img :src="item.creator_info && item.creator_info.avatar ? item.creator_info.avatar : defaultImg"
                                                 alt=""/>
                                            <span class="ellipsis">{{
                                                    item.creator_info && item.creator_info.name
                                                }}</span>
                                        </div>
                                    </div>
                                </userDetailPopover>

                                <div class="time_info ellipsis" @click.stop="handleClickApproveItem(item)">
                                    <span>{{
                                            searchForm.processState === "awaiting_my_action" ? "申请时间：" : searchForm.processState === "already_handled_by_me" ? "处理时间：" : ""
                                        }}</span>
                                    {{ item.approval_date }}
                                </div>
                            </div>
                        </div>
                        <div class="bottom" v-if="item.overview_fields && item.overview_fields.length > 0">

                            <OverviewFields :overviewFields="item.overview_fields"/>


                        </div>
                    </li>
                    <div class="node_data_wrap" v-if="approvalList.length === 0">暂无数据</div>
                </ul>
            </div>
        </div>
        <div class="approval_center_detail" id="approval_center_detail" ref="approval_center_detail" v-loading="approvalDetailLoading">
            <div class="approval_center_detail_top" v-if="approvalDetailInfo.approval_id">
                <div class="title_id_print_info">
                    <div class="title_info">
                        <h5>
                            {{
                                approvalDetailInfo &&
                                approvalDetailInfo.approval_set &&
                                approvalDetailInfo.approval_set.name
                            }}
                        </h5>
                        <span :class="'approval_status_' + approvalDetailInfo.approval_status">{{
                                getApprovalStatusText(approvalDetailInfo.approval_status)
                            }}</span>
                    </div>
                    <div class="id_print_info">
                        <span class="id">ID:{{ approvalDetailInfo.approval_id }}</span>
                        <span class="handle_icon_wrap" @click="printPage">
                            <i class="iconfont icon-dayin1"></i>
                        </span>
                    </div>
                </div>

                <div class="user_time_handle_info">
                    <div class="user_time_info">
                        <userDetailPopover v-if="approvalDetailInfo.creator_info"
                                           :uid="approvalDetailInfo.creator_info.id">
                            <div slot="container">
                                <div class="user_info ellipsis">
                                    <img :src="approvalDetailInfo && approvalDetailInfo.creator_info &&   approvalDetailInfo.creator_info.avatar  ? approvalDetailInfo.creator_info.avatar  : defaultImg"
                                         alt=""/>
                                    <span class="ellipsis">{{
                                            approvalDetailInfo && approvalDetailInfo.creator_info ? approvalDetailInfo && approvalDetailInfo.creator_info.name : ""
                                        }}</span>
                                </div>
                            </div>
                        </userDetailPopover>

                        <div class="time_info ellipsis">
                            <span>申请时间：</span>{{ approvalDetailInfo && approvalDetailInfo.created_at }}
                        </div>
                    </div>
                    <div class="handle_wrap">
                        <span
                                :class="anchorActive == 'anchor1' ? 'font_bold active' : ''"
                                class="custom_hover_active_class"
                                @click="handleClickAnchor('anchor1')"
                        >详情</span
                        >
                        <span
                                :class="anchorActive == 'anchor2' ? 'font_bold active' : ''"
                                class="custom_hover_active_class"
                                @click="handleClickAnchor('anchor2')"
                        >流程</span
                        >
                        <span
                                v-show="approveCommentList.length > 0"
                                :class="anchorActive == 'anchor3' ? 'font_bold active' : ''"
                                class="custom_hover_active_class"
                                @click="handleClickAnchor('anchor3')"
                        >评论({{ approveCommentList.length }})</span
                        >
                    </div>
                </div>
            </div>
            <div
                    v-if="approvalDetailInfo.approval_id"
                    ref="approval_center_detail_wrap"
                    class="approval_center_detail_wrap"
            >
                <div class="approval_center_detail_title_wrap"><span>审批详情</span></div>
                <div class="approval_center_detail_detail" ref="anchor1">
                    <CustomFormDetailPc
                            v-if="dataLoaded"
                            ref="customFormPc"
                            :field_list="formInfoList"
                            :form_detail="formData"
                            :is_edit_mode="false"
                            :pk_id="approvalDetailInfo.approval_id"
                            :business_data="business_data"
                            :node_list="approver_list"/>
                    <!-- :pk_id="user_id"-->
                    <!-- @submit-form="summitFormData"-->
                    <!--系统审批详情-->
                    <SystemApprovalDetail
                            v-if="approvalDetailInfo && approvalDetailInfo.approval_content && approvalDetailInfo.approval_content.content &&  approvalDetailInfo.approval_content.content.details"
                            :form_detail="approvalDetailInfo.approval_content.content.details"
                            :business_data="approvalDetailInfo.approval_content.content.business_data"
                            :approval_type="approvalDetailInfo.approval_type"
                            :approvalDetailInfo="approvalDetailInfo"
                    />
                </div>
                <div class="approval_center_detail_title_wrap"><span>审批流程</span></div>
                <div class="approval_center_detail_process" ref="anchor2">
                    <approvalProcessDetails
                            :approvalNodeList="approvalNodeList"
                            :approvalStatus="approvalDetailInfo.approval_status"
                            :currentUserApprovalPermission="currentUserApprovalPermission"
                            @cancelAddSignSuccess="initData(searchForm.processState)"
                    ></approvalProcessDetails>
                </div>
                <div class="approval_center_detail_title_wrap" v-if="approveCommentList.length > 0">
                    <span>评论</span>
                </div>
                <div class="approval_center_detail_comment" ref="anchor3" v-show="approveCommentList.length > 0">
                    <ul>
                        <li v-for="comment in approveCommentList">
                            <div class="process_user_info_wrap">
                                <div class="user_header_wrap">
                                    <img
                                            :src="
                                            comment.creator_info && comment.creator_info.avatar
                                                ? comment.creator_info.avatar
                                                : defaultImg
                                        "
                                            alt=""
                                            class="header_img"
                                            onerror=""
                                    />
                                </div>
                                <div class="user_name">{{ comment.creator_info && comment.creator_info.name }}</div>
                                <div class="handle_time">{{ comment.created_at }}</div>
                            </div>
                            <div class="content_outer_wrap">
                                <div class="content_inner_wrap">
                                    <p v-if="comment.content" v-html="comment.content"></p>
                                    <template v-if="comment.pic_list && comment.pic_list.length">
                                        <img
                                                v-for="imgItem in comment.pic_list"
                                                :src="imgItem.file_path"
                                                class="commentImage"
                                                @click="handleClickPreviewImg(imgItem, comment.pic_list)"
                                        />
                                    </template>
                                    <div
                                            v-if="comment.file_list && comment.file_list.length"
                                            class="upload_file_list_detail"
                                    >
                                        <div class="upload_file_item" v-for="file in comment.file_list">
                                            <div class="file_left_wrap">
                                                <img src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                                     alt="" class="file_img"/>
                                            </div>
                                            <div class="file_info_wrap">
                                                <p class="ellipsis">{{ file.file_name }}</p>
                                                <span>{{ file.file_size }}</span>
                                            </div>
                                            <div class="file_right_wrap">
                                                <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                    <i class="iconfont icon-yanjing"></i>
                                                </span>
                                                <span class="handle_icon_wrap" @click="handleClickDownloadFile(file)">
                                                    <i class="iconfont icon-daochu"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="approval_center_detail_bottom" v-if="approvalDetailInfo.approval_id">
                <div
                        class="agree_btn"
                        v-if="
                        approvalDetailInfo.approval_status == 0 &&
                        currentUserApprovalPermission &&
                        currentUserApprovalPermission.button &&
                        (currentUserApprovalPermission.button.pass_button ||
                            currentUserApprovalPermission.button.quick_pass_button)
                    "
                >
                    <el-popover
                            v-if="
                            currentUserApprovalPermission &&
                            currentUserApprovalPermission.button &&
                            currentUserApprovalPermission.button.pass_button
                        "
                            v-model="agree_popover_show"
                            placement="top"
                            trigger="click"
                            width="504"
                            @hide="handleClickAgreeClose"
                    >

                        <span slot="reference" class="agree_btn_btn"
                              v-text="currentApproval.type == 'conduct' ? '确认' : '同意'"></span>
                        <div class="approval_submit_form">
                            <div class="approval_submit_form_title"
                                 v-text="currentApproval.type == 'conduct' ? '确认' : '同意'"></div>
                            <div class="approval_submit_form_wrap">
                                <el-input
                                        v-model="approval_handle_form.agree_text"
                                        :rows="6"
                                        maxlength="200"
                                        placeholder="请输入审批意见（选填）"
                                        show-word-limit
                                        type="textarea"
                                ></el-input>
                            </div>
                            <div class="approval_submit_form_btn">
                                <el-button size="small" @click="handleClickAgreeClose">取消</el-button>
                                <el-button
                                        :disabled="btnDisabled"
                                        size="small"
                                        type="primary"
                                        @click="handleClickAgreeConfirm"
                                >确定
                                </el-button
                                >
                            </div>
                        </div>
                    </el-popover>
                    <span
                            v-if="
                            currentUserApprovalPermission &&
                            currentUserApprovalPermission.button &&
                            currentUserApprovalPermission.button.quick_pass_button
                        "
                            @click="handleClickQuickAgreeConfirm"
                    ><i class="iconfont icon-shandian"></i
                    ></span>
                </div>
                <el-popover
                        v-if="
                        approvalDetailInfo.approval_id &&
                        currentUserApprovalPermission.button &&
                        currentUserApprovalPermission.button.rejection_button &&
                        currentApproval.type!='conduct'
                    "
                        v-model="refuse_popover_show"
                        placement="top"
                        trigger="click"
                        width="504"
                        @hide="handleClickRefuseClose"
                >
                    <div slot="reference" class="refuse_btn">拒绝</div>
                    <div class="approval_submit_form">
                        <div class="approval_submit_form_title">拒绝</div>
                        <div class="approval_submit_form_wrap">
                            <el-input
                                    v-model="approval_handle_form.refuse_text"
                                    :rows="6"
                                    maxlength="200"
                                    placeholder="请输入审批意见（选填）"
                                    show-word-limit
                                    type="textarea"
                            ></el-input>
                        </div>
                        <div class="approval_submit_form_btn">
                            <el-button size="small" @click="handleClickRefuseClose">取消</el-button>
                            <el-button
                                    :disabled="btnDisabled"
                                    size="small"
                                    type="primary"
                                    @click="handleClickRefuseConfirm"
                            >确定
                            </el-button
                            >
                        </div>
                    </div>
                </el-popover>

                <el-popover
                        v-if="
                        approvalDetailInfo.approval_id &&
                        currentUserApprovalPermission.button &&
                        currentUserApprovalPermission.button.comment_button
                    "
                        v-model="comment_popover_show"
                        placement="top"
                        trigger="manual"
                        width="504"
                >
                    <div slot="reference" class="handle_btn custom_hover_active_class" @click="comment_popover_show = !comment_popover_show">
                        <i class="iconfont icon-pinglun" ></i><span>评论</span>
                    </div>
                    <div class="approval_submit_form">
                        <div class="approval_submit_form_title">评论</div>
                        <div class="approval_submit_form_wrap">
                            <commentComponent v-if="comment_popover_show"
                                    ref="commentComponentRef"
                                    :placeholderText="'请输入评论,可@相关人员...'"
                            ></commentComponent>
                        </div>
                        <div class="approval_submit_form_btn">
                            <el-button size="small" @click="handleClickCommentClose">取消</el-button>
                            <el-button
                                    :disabled="btnDisabled"
                                    size="small"
                                    type="primary"
                                    @click="handleClickCommentConfirm"
                            >发送
                            </el-button
                            >
                        </div>
                    </div>
                </el-popover>

                <el-popover
                        v-if="
                        approvalDetailInfo.approval_id &&
                        currentUserApprovalPermission.button &&
                        currentUserApprovalPermission.button.copy_button
                    "
                        v-model="make_popover_show"
                        placement="top"
                        trigger="click"
                        width="360"
                >
                    <div slot="reference" class="handle_btn custom_hover_active_class">
                        <i class="iconfont icon-chaosong1"></i><span>抄送</span>
                    </div>
                    <div class="approval_submit_form">
                        <div class="approval_submit_form_title">抄送</div>
                        <div class="approval_submit_form_wrap">
                            <el-select
                                    v-model="approval_handle_form.make_uid"
                                    :remote-method="getUserList"
                                    clearable
                                    collapse-tags
                                    filterable
                                    multiple
                                    placeholder="请搜索或选择抄送人员"
                                    remote
                                    size="small"
                            >
                                <el-option
                                        v-for="user in userList"
                                        :key="user.uid"
                                        :label="user.name"
                                        :value="user.uid"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="approval_submit_form_btn">
                            <el-button size="small" @click="handleClickMakeClose">取消</el-button>
                            <el-button
                                    :disabled="btnDisabled"
                                    size="small"
                                    type="primary"
                                    @click="handleClickMakeConfirm"
                            >抄送
                            </el-button
                            >
                        </div>
                    </div>
                </el-popover>

                <el-popconfirm
                        v-if="
                        approvalDetailInfo.approval_id &&
                        currentUserApprovalPermission.button &&
                        currentUserApprovalPermission.button.cancel_button
                    "
                        cancel-button-text="取消"
                        cancel-button-type=""
                        confirm-button-text="确定"
                        title="确定撤销该审批吗？"
                        @cancel="handleClickRevokeCancel"
                        @confirm="handleClickRevokeConfirm"
                >
                    <div slot="reference" class="handle_btn custom_hover_active_class">
                        <i class="iconfont icon-chexiao"></i><span>撤销</span>
                    </div>
                </el-popconfirm>

                <el-tooltip v-if="approvalDetailInfo.approval_id && currentUserApprovalPermission.button && currentUserApprovalPermission.button.submit_again_button" :disabled="approvalDetailInfo.approval_type == '' ? true  : false"   content="系统业务审批无法再次提交，可通过对应功能模板发起" effect="dark" placement="top">
                    <div :class="{ handle_btn_disabled:  approvalDetailInfo.approval_type != ''}" class="handle_btn custom_hover_active_class">
                        <span @click="handleClickAgainConfirm"><i class="iconfont icon-zaicitijiao"></i><span>再次提交</span></span>
                    </div>
                </el-tooltip>

<!--                <el-tooltip v-if="no_approval_edit_list.indexOf(approvalDetailInfo.approval_type) < 0" :content="currentApproval.edit_auth_tooltip"   :disabled="currentUserApprovalPermission && currentUserApprovalPermission.button && currentUserApprovalPermission.button.edit_button"  effect="dark"  placement="top">-->
<!--                    <div  :class="{ handle_btn_disabled: approvalDetailInfo.approval_id && currentUserApprovalPermission.button && currentUserApprovalPermission.button.edit_button == false}"  class="handle_btn custom_hover_active_class" >-->
<!--                       <span @click="handleClickEdit"><i class="iconfont icon-bianji"></i><span>修改</span></span>-->
<!--                    </div>-->
<!--                </el-tooltip>-->

                <el-dropdown
                        v-if="
                        approvalDetailInfo.approval_id &&
                        currentUserApprovalPermission.button &&
                        (currentUserApprovalPermission.button.transfer_button ||
                            currentUserApprovalPermission.button.add_signature_button ||
                            currentUserApprovalPermission.button.return_button)
                    "
                        ref="approveMore"
                        :hide-on-click="false"
                        placement="bottom-start"
                        trigger="manual"
                        @command="handleCommandMore">
                    <div class="handle_btn custom_hover_active_class" @click="handleClickApproveMore">
                        <i class="iconfont icon-gengduo"></i><span>更多</span>
                    </div>
                    <el-dropdown-menu slot="dropdown" ref="approveMoreMenu">
                        <el-popover
                                v-if="
                                approvalDetailInfo.approval_id &&
                                currentUserApprovalPermission.button &&
                                currentUserApprovalPermission.button.transfer_button
                            "
                                v-model="pass_popover_show"
                                placement="top"
                                trigger="click"
                                width="360"
                        >
                            <el-dropdown-item slot="reference" command="1"
                            ><i class="iconfont icon-a-zhaunjiao dropdown_icon"></i>转交
                            </el-dropdown-item
                            >
                            <div class="approval_submit_form">
                                <div class="approval_submit_form_title">转交</div>
                                <div class="approval_submit_form_wrap">
                                    <el-select
                                            v-model="approval_handle_form.pass_uid"
                                            :remote-method="getUserList"
                                            clearable
                                            filterable
                                            placeholder="请搜索或选择转交人员"
                                            remote
                                            size="small"
                                    >
                                        <el-option
                                                v-for="user in userList"
                                                :key="user.uid"
                                                :label="user.name"
                                                :value="user.uid"
                                        >
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="approval_submit_form_btn">
                                    <el-button size="small" @click="handleClickPassClose">取消</el-button>
                                    <el-button
                                            :disabled="btnDisabled"
                                            size="small"
                                            type="primary"
                                            @click="handleClickPassConfirm"
                                    >转交
                                    </el-button
                                    >
                                </div>
                            </div>
                        </el-popover>

                        <el-popover
                                v-if="
                                approvalDetailInfo.approval_id &&
                                currentUserApprovalPermission.button &&
                                currentUserApprovalPermission.button.add_signature_button
                            "
                                v-model="countersign_popover_show"
                                placement="top"
                                trigger="click"
                                width="360"
                        >
                            <el-dropdown-item slot="reference" command="2"
                            ><i class="iconfont icon-jiaqian dropdown_icon"></i>加签
                            </el-dropdown-item
                            >
                            <div class="approval_submit_form">
                                <div class="approval_submit_form_title">加签</div>
                                <div class="approval_submit_form_wrap">
                                    <el-select
                                            v-model="approval_handle_form.countersign_uid"
                                            :remote-method="getUserList"
                                            clearable
                                            filterable
                                            placeholder="请搜索或选择加签人员"
                                            remote
                                            size="small"
                                    >
                                        <el-option
                                                v-for="user in userList"
                                                :key="user.uid"
                                                :label="user.name"
                                                :value="user.uid"
                                        >
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="approval_submit_form_btn">
                                    <el-button size="small" @click="handleClickCountersignClose">取消</el-button>
                                    <el-button
                                            :disabled="btnDisabled"
                                            size="small"
                                            type="primary"
                                            @click="handleClickCountersignConfirm"
                                    >加签
                                    </el-button
                                    >
                                </div>
                            </div>
                        </el-popover>

                        <el-popconfirm
                                v-if="
                                approvalDetailInfo.approval_id &&
                                currentUserApprovalPermission.button &&
                                currentUserApprovalPermission.button.return_button
                            "
                                cancel-button-text="取消"
                                cancel-button-type=""
                                confirm-button-text="确定"
                                title="确定回退该审批吗？"
                                @cancel="handleClickBackCancel"
                                @confirm="handleClickBackConfirm"
                        >
                            <el-dropdown-item slot="reference" command="3"
                            ><i class="iconfont icon-huitui dropdown_icon"></i>回退
                            </el-dropdown-item
                            >
                        </el-popconfirm>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <el-image :src="previewImgSrc" :preview-src-list="previewImgList" ref="preview_img" style="display: none">
        </el-image>
        <RelatedHandle ref="relatedHandle" @relatedHandleSuccess="relatedHandleSuccess"/>
    </div>
</template>

<script>
import {mapState} from "vuex";
import {
    approvalCenterTypeList,
    approvalCenterOverviewList,
    approvalDetail,
    passApproval,
    cancelApproval,
    rejectionApproval,
    approvalAddSign,
    approvalTransfer,
    GetUserList,
    approvalFallback,
    addComment,
    commentList,
    copyToSomeone,
    GetCurrentUserApprovalPermission,
    ApprovalStateTypeNum,
    AllApprovalSetList,
    MarkAllAsRead,
    MakeAsRead
} from "@/api";
import CustomFormDetailPc from "@/components/pComponents/CustomFormDetailPc";
import commentComponent from "./component/commentComponent";
import approvalProcessDetails from "@/components/pComponents/approvalProcessDetails";
import SystemApprovalDetail from "@/components/pComponents/systemApprovalDetail";
import OverviewFields from "@/components/pComponents/overviewFields";
import userDetailPopover from "@/components/pComponents/userDetailPopover";
import RelatedHandle from "./component/related_handle"
export default {
    name: "approvalCenter",
    components: {
        commentComponent,
        approvalProcessDetails,
        CustomFormDetailPc,
        SystemApprovalDetail,
        OverviewFields,
        userDetailPopover,
        RelatedHandle
    },
    data() {
        return {

            defaultImg: require("@/assets/images/default.jpg"),
            searchForm: {
                keyword: "",
                list_update_date: "", //时间筛选
                timeFilterText: "所有时间", //时间筛选text
                customDate: "", //自定义时间
                approve_status: "", //审批状态
                processState: "awaiting_my_action", //审批流程
                sort_field: "", //排序
                approval_set_id: "",
            },
            approval_tab_list: [
                {
                    state: "awaiting_my_action",
                    name: "待我处理",
                    icon: "icon-daichuli",
                    activeIcon: "icon-daichulimian",
                    total: "0",
                    isPackUp: false,
                    children: [],
                },
                {
                    state: "already_handled_by_me",
                    name: "我已处理",
                    icon: "icon-yichuli",
                    activeIcon: "icon-yichulimian",
                    total: "0",
                    isPackUp: false,
                    children: [],
                },
                {
                    state: "received_by_me",
                    name: "我收到的",
                    icon: "icon-yishoudao",
                    activeIcon: "icon-yishoudaomian",
                    total: "0",
                    isPackUp: false,
                    at_make: [
                        {
                            state: "copy_by_me",
                            p_state: "received_by_me",
                            name: "抄送我",
                            icon: "icon-chaosong",
                            activeIcon: "icon-chaosong",
                            isPackUp: false,
                            children: [],
                        },
                        {
                            state: "at_by_me",
                            p_state: "received_by_me",
                            name: "@我",
                            icon: "icon-a-",
                            activeIcon: "icon-a-",
                            isPackUp: false,
                            children: [],
                        },
                    ],
                },
                {
                    state: "initiated_by_me",
                    name: "我发起的",
                    icon: "icon-yifaqi",
                    activeIcon: "icon-yifaqimian",
                    total: "0",
                    isPackUp: false,
                    children: [],
                },
            ],
            stateTypeNum: {
                pending_num: 0, // 待审批数量
                received_num: 0, // 已收到数量（未读数量）
            }, //
            isExpand: false, //展开收起
            approvalTypeListLoading:false,
            approvalCenterLoading: false,
            approvalDetailLoading: false,
            approvalPage: 1,
            approvalListTotal: 0,
            approvalListLoading: false,
            approvalList: [], // 审批概览区列表
            approvalDetailInfo: {}, // 详情
            approvalNodeList: [], // 审批流程
            approveCommentList: [], // 评论
            approveCommentCount: 0,
            searchFilterList: [
                {
                    field_key: "approval_set_id",
                    field_name: "审批类型",
                    field_value: [],
                    field_type: "eq",
                },
                {
                    field_key: "creator_uid",
                    field_name: "发起人",
                    field_value: [],
                    field_type: "eq",
                },
            ],
            approval_handle_form: {
                agree_text: "", //审批同意
                refuse_text: "", //审批拒绝
                make_uid: [], //审批抄送
                countersign_uid: "", //审批加签
                pass_text: "", //审批转交原因
                pass_uid: "", //审批转交人
            },
            btnDisabled: false,
            agree_popover_show: false, //审批同意弹窗
            refuse_popover_show: false, //审批拒绝弹窗
            make_popover_show: false, //审批抄送弹窗
            countersign_popover_show: false, //审批加签弹窗
            pass_popover_show: false, //审批转交弹窗
            comment_popover_show: false, //评论弹窗
            anchorActive: "anchor1",

            formInfoList: [],
            formData: {},
            dataLoaded: false,
            currentApproval: {}, // 当前需要操作的节点信息
            currentUserApprovalPermission: {}, // 当前用户的可操作按钮权限
            carbonCopyUserIds: [], // 所有流程中的用户
            userList: [], // 用户列表
            previewImgSrc: "", //预览图片
            previewImgList: [],
            approvalSetTypeList: [], // 审批类型
            business_data: {},
            approver_list: [],
            no_approval_edit_list:['customer_claim'], //不可以编辑的审批
        };
    },
    computed: {
        ...mapState(["userInfo"]),
        owner_uid() {
            return this.userInfo && this.userInfo.user && this.userInfo.user.id;
        },
    },
    created() {
        this.getUserList();
        this.getAllApprovalSetList();
    },
    mounted() {
    },
    methods: {
        openDialog() {
            this.$showApprovalDetail({
                approval_id: 1,
            }).then((res) => {
                console.log(res)
            });
        },
        printPage() {
            const routeUrl = this.$router.resolve({ name: 'ApprovalPrint',query:{id:this.approvalId,process_state:this.searchForm.processState} }).href; // 获取路由的 URL
            const newWindow = window.open(routeUrl, '_blank',);
        },
        // 查看图片
        handleClickPreviewImg(previewImg, previewImgList) {
            this.$refs.preview_img.showViewer = true;
            this.previewImgSrc = previewImg.file_path;
            this.previewImgList = previewImgList.map((item) => item.file_path);
        },
        //点击预览
        handleClickPreview(file) {
            let str = file.file_path.split(".")[file.file_path.split(".").length - 1];
            if (str.indexOf('png') > -1 || str.indexOf('jpg') > -1 || str.indexOf('jpeg') > -1 || str.indexOf('gif') > -1) {
                this.$refs.preview_img.showViewer = true;
                this.previewImgList = [file.file_path];
                this.previewImgSrc = file.file_path;
            } else {
                if (str.indexOf("pdf") > -1) {
                    window.open(file.file_path);
                } else {
                    this.$message.error("当前文件格式不支持预览，请下载后查看");
                }
            }
        },
        // 下载附件
        handleClickDownloadFile(file) {
            var url = `${file.file_path}?response-content-disposition=attachment%3B%20filename%3D${file.file_name}`;
            window.location.href = url;
        },

        // 清空筛选条件
        handleClickReset() {
            this.searchFilterList.forEach((item) => {
                this.$set(item, "field_value", []);
            });
            this.initData(this.searchForm.processState);
        },
        // 左侧展开收起
        handleClickExpand() {
            this.isExpand = !this.isExpand;
        },
        // 点击切换审批分类
        handleClickApprovalTab(item) {
            if(this.approvalListLoading == true || this.approvalCenterLoading == true){
                return false
            }
            this.approval_tab_list.forEach((tab) => {
                if (!item.p_state && item.p_state != tab.state) {
                    this.$set(tab, "isPackUp", false);
                }
                if (tab.at_make) {
                    tab.at_make.forEach((child) => {
                        this.$set(child, "isPackUp", false);
                    });
                }
            });
            this.searchForm.processState = item.state;
            this.searchForm.approval_set_id = "";
            item.isPackUp = true;
            this.approvalPage = 1;
            this.approvalList = []
            this.getApprovalCenterTypeList(item);
        },
        // 左侧分类展开收起
        handleClickApprovalDropDown(item){
          item.isPackUp = !item.isPackUp
          if(item.isPackUp){
              this.handleClickApprovalTab(item)
          }
        },
        // 点击分类下的类型
        handleClickStateTypeItem(child, item) {
            if (this.searchForm.processState !== item.state) {
                this.searchForm.processState = item.state;
            }
            this.searchForm.approval_set_id = child.approval_set_id;
            this.approvalPage = 1;
            this.getApprovalCenterOverviewList();
        },
        // 切换时间筛选
        handleDateCommand(command) {
            let list_update_date = "";
            if (command === "custom") {
                this.searchForm.timeFilterText = "自定义时间范围";
                return false;
            } else if (command === "") {
                list_update_date = "";
                this.searchForm.timeFilterText = "所有时间";
            } else if (command === "1") {
                list_update_date = this.getDateRange(24);
                this.searchForm.timeFilterText = "最近24小时";
            } else if (command === "7") {
                list_update_date = this.getDateRange(null, 7);
                this.searchForm.timeFilterText = "最近7天";
            } else if (command === "30") {
                list_update_date = this.getDateRange(null, 30);
                this.searchForm.timeFilterText = "最近30天";
            }
            this.$refs.updateDateCommand.hide();
            this.searchForm.list_update_date = list_update_date;
            this.overviewFilter();
        },
        // 选择自定义时间
        handleCustomDateChange(val) {
            if (val && val.length) {
                this.searchForm.timeFilterText = val[0] + "-" + val[1];
                this.searchForm.list_update_date = val[0] + " - " + val[1];
                this.$refs.customDatePopover.doClose();
                this.$refs.updateDateCommand.hide();
            }
            this.overviewFilter();
        },

        // 获取时间
        getDateRange(lastHours, lastDays) {
            const now = new Date();
            let startDate, endDate;
            // 获取最近24小时的日期区间
            if (lastHours) {
                const twentyFourHoursAgo = new Date(now.getTime() - lastHours * 60 * 60 * 1000);
                startDate = `${twentyFourHoursAgo.getFullYear()}-${(twentyFourHoursAgo.getMonth() + 1)
                        .toString()
                        .padStart(2, "0")}-${twentyFourHoursAgo.getDate().toString().padStart(2, "0")} ${twentyFourHoursAgo
                        .getHours()
                        .toString()
                        .padStart(2, "0")}:${twentyFourHoursAgo.getMinutes().toString().padStart(2, "0")}`;
                endDate = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, "0")}-${now
                        .getDate()
                        .toString()
                        .padStart(2, "0")}`;
            }
            // 获取最近7天的日期区间
            if (lastDays) {
                const sevenDaysAgo = new Date(now.getTime() - (lastDays - 1) * 24 * 60 * 60 * 1000);
                startDate = `${sevenDaysAgo.getFullYear()}-${(sevenDaysAgo.getMonth() + 1)
                        .toString()
                        .padStart(2, "0")}-${sevenDaysAgo.getDate().toString().padStart(2, "0")}`;
                endDate = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, "0")}-${now
                        .getDate()
                        .toString()
                        .padStart(2, "0")}`;
            }
            return startDate + " - " + endDate;
        },
        // 切换状态筛选
        handleStatusCommand(command) {
            this.$refs.approveStatus.hide();
            this.searchForm.approve_status = command;
            this.overviewFilter();
        },
        // 排序
        handleSortCommand(command) {
            this.searchForm.sort_field = command;
            this.$refs.approveSort.hide();
            this.overviewFilter();
        },
        // 概览区筛选
        overviewFilter() {
            this.approvalPage = 1;
            this.formInfoList = [];
            this.formData = {};
            this.dataLoaded = false;
            this.getApprovalCenterOverviewList();
        },

        handleClickAnchor(ref) {
            this.anchorActive = ref;
            const targetElement = this.$refs[ref];
            if (targetElement) {
                this.$refs.approval_center_detail_wrap.scrollTo({
                    top: targetElement.offsetTop - 214,
                    behavior: "smooth", // 平滑滚动
                });
            }
        },
        // 审批同意取消
        handleClickAgreeClose() {
            this.approval_handle_form.agree_text = "";
            this.agree_popover_show = false;
        },
        // 审批同意确定
        handleClickAgreeConfirm() {
            // 查找需要操作的流程节点
            const node_id = this.currentApproval ? this.currentApproval.node_id : "";
            if (node_id) {
                this.btnDisabled = true;
                const params = {
                    approval_id: this.approvalId,
                    node_id,
                    content: this.approval_handle_form.agree_text,
                };
                passApproval(params)
                        .then((res) => {
                            if (res.code === 200) {
                                this.$message.success(this.currentApproval.type == "conduct" ? '已确认' : '已同意');
                                this.initData(this.searchForm.processState);
                            }
                            this.btnDisabled = false;
                            this.handleClickAgreeClose();
                        })
                        .catch(() => {
                            this.btnDisabled = false;
                        });
            }
        },
        // 审批快速通过
        handleClickQuickAgreeConfirm() {
            // 查找需要操作的流程节点
            const node_id = this.currentApproval ? this.currentApproval.node_id : "";
            if (node_id) {
                const params = {
                    approval_id: this.approvalId,
                    node_id,
                    content: this.approval_handle_form.agree_text,
                };
                passApproval(params).then((res) => {
                    if (res.code === 200) {
                        this.$message.success(this.currentApproval.type == "conduct" ? '已确认' : '已同意');
                        this.initData(this.searchForm.processState);
                    }
                });
            }
        },
        // 审批拒绝取消
        handleClickRefuseClose() {
            this.approval_handle_form.refuse_text = "";
            this.refuse_popover_show = false;
        },
        // 审批拒绝确定
        handleClickRefuseConfirm() {
            // 查找需要操作的流程节点
            const node_id = this.currentApproval ? this.currentApproval.node_id : "";
            if (node_id) {
                this.btnDisabled = true;
                const params = {
                    approval_id: this.approvalId,
                    node_id,
                    content: this.approval_handle_form.refuse_text,
                };
                rejectionApproval(params)
                        .then((res) => {
                            if (res.code === 200) {
                                this.$message.success('已拒绝');
                                this.initData(this.searchForm.processState);
                            }
                            this.btnDisabled = false;
                            this.handleClickRefuseClose();
                        })
                        .catch(() => {
                            this.btnDisabled = false;
                        });
            }
        },
        // 审批抄送取消
        handleClickMakeClose() {
            this.approval_handle_form.make_uid = [];
            this.make_popover_show = false;
        },
        // 审批抄送确定
        handleClickMakeConfirm() {
            // 查找需要操作的流程节点
            // 没处理的审批获取当前待办的节点
            // status == 1 已通过的审批获取结束节点
            // status == 2 驳回的获取驳回的那个节点
            // 否则都不满足是最后一个节点
            let  node_id = ''
            if(this.approvalDetailInfo.status  == 0){
              node_id =  this.currentApproval ? this.currentApproval.node_id : this.approvalDetailInfo.node_list[this.approvalDetailInfo.node_list.length-1].node_id;
            }else if(this.approvalDetailInfo.status  == 1){
              node_id = this.approvalDetailInfo.node_list[this.approvalDetailInfo.node_list.length-1].node_id;
            }else if(this.approvalDetailInfo.status  == 2){
              node_id = this.approvalDetailInfo.node_list.find(find => find.status == 2)?.node_id
            }else{
              node_id = this.approvalDetailInfo.node_list[0].node_id;
            }

            if (!this.approval_handle_form.make_uid.length) return this.$message.error("请选择抄送人员");
            if (node_id) {
                this.btnDisabled = true;
                const params = {
                    approval_id: this.approvalId,
                    node_id,
                    cc_uids: this.approval_handle_form.make_uid,
                };
                copyToSomeone(params)
                        .then((res) => {
                            if (res.code === 200) {
                                this.$message.success(res.message);
                                this.initData(this.searchForm.processState);
                            }
                            this.btnDisabled = false;
                            this.handleClickMakeClose();
                        })
                        .catch(() => {
                            this.btnDisabled = false;
                        });
            }
        },
        // 点击更多按钮
        handleClickApproveMore() {
            this.$refs.approveMoreMenu.$data.showPopper = !this.$refs.approveMoreMenu.$data.showPopper
            this.$refs.approveMoreMenu.visible = true
        },
        handleCommandMore(value) {
            if (value == 2) {
                this.pass_popover_show = false
            } else if (value == 3) {
                this.pass_popover_show = false
                this.countersign_popover_show = false
            }
        },
        handleClickCountersignClose() {
            this.approval_handle_form.countersign_uid = "";
            this.countersign_popover_show = false;
            this.$refs.approveMoreMenu.$data.showPopper = false
        },
        // 加签
        handleClickCountersignConfirm() {
            // 查找需要操作的流程节点
            const node_id = this.currentApproval ? this.currentApproval.node_id : "";
            if (!this.approval_handle_form.countersign_uid) return this.$message.error("请选择加签人员");
            if (this.currentApproval.handle_info.find(find => find.uid == this.approval_handle_form.countersign_uid)) return this.$message.error("此人员已在当前节点中");
            if (node_id) {
                this.btnDisabled = true;
                const params = {
                    approval_id: this.approvalId,
                    node_id,
                    user_id: this.approval_handle_form.countersign_uid,
                    approval_mode:this.currentApproval.approval_mode
                };
                approvalAddSign(params)
                        .then((res) => {
                            if (res.code === 200) {
                                this.$message.success('加签成功');
                                this.initData(this.searchForm.processState);
                            }
                            this.btnDisabled = false;
                            this.handleClickCountersignClose();
                        })
                        .catch(() => {
                            this.btnDisabled = false;
                        });
            }
            this.$refs.approveMoreMenu.$data.showPopper = false
        },
        handleClickPassClose() {
            this.approval_handle_form.pass_uid = "";
            this.approval_handle_form.pass_text = "";
            this.pass_popover_show = false;
            this.$refs.approveMoreMenu.$data.showPopper = false
        },
        // 转交
        handleClickPassConfirm() {
            // 查找需要操作的流程节点
            const node_id = this.currentApproval ? this.currentApproval.node_id : "";
            if (!this.approval_handle_form.pass_uid) return this.$message.error("请选择转交人员");
            if (this.currentApproval.handle_info.find(find => find.uid == this.approval_handle_form.pass_uid)) return this.$message.error("此人员已在当前节点中");

            if (node_id) {
                this.btnDisabled = true;
                const params = {
                    approval_id: this.approvalId,
                    node_id,
                    user_id: this.approval_handle_form.pass_uid,
                };
                approvalTransfer(params)
                        .then((res) => {
                            if (res.code === 200) {
                                this.$message.success('转交成功');
                                this.initData(this.searchForm.processState);
                            }
                            this.btnDisabled = false;
                            this.handleClickCountersignClose();
                        })
                        .catch(() => {
                            this.btnDisabled = false;
                        });
            }
            this.$refs.approveMoreMenu.$data.showPopper = false
        },

        // 审批撤销取消
        handleClickRevokeCancel() {
        },
        // 审批撤销确定
        handleClickRevokeConfirm() {
            const node_id = this.currentApproval ? this.currentApproval.node_id : "";
            if (node_id) {
                const params = {
                    approval_id: this.approvalId,
                    node_id,
                };
                cancelApproval(params)
                        .then((res) => {
                            if (res.code === 200) {
                                this.$message.success('撤销成功');
                                this.initData(this.searchForm.processState);
                            }
                        })
                        .catch(() => {
                            this.btnDisabled = false;
                        });
            }
        },
        // 审批回退取消
        handleClickBackCancel() {
            this.$refs.approveMoreMenu.$data.showPopper = false
        },
        // 审批回退确定
        handleClickBackConfirm() {
            if (this.currentApproval && this.currentApproval.sort == 2) {
                this.$message.error("第一个节点不允许回退");
                return false
            }
            const node_id = this.currentApproval ? this.currentApproval.node_id : "";
            if (node_id) {
                this.btnDisabled = true;
                approvalFallback({approval_id: this.approvalId, node_id})
                        .then((res) => {
                            if (res.code === 200) {
                                this.$message.success('回退成功');
                                this.initData(this.searchForm.processState);
                            }
                            this.btnDisabled = false;
                            this.handleClickBackCancel();
                        })
                        .catch(() => {
                            this.btnDisabled = false;
                        });
            }
            this.$refs.approveMoreMenu.$data.showPopper = false
        },
        // 评论取消
        handleClickCommentClose() {
            this.approval_handle_form.countersign_uid = "";
            this.comment_popover_show = false;
        },
        // 评论确定发送
        handleClickCommentConfirm() {
            let data = this.$refs.commentComponentRef.getCommentContent();
            if (!data.content && !data.at_uid && !data.files.length && !data.img.length)
                return this.$message.error("请输入些内容");
            const params = {
                approval_id: this.approvalId,
                atPeople: data.at_people,
                file_list: data.files,
                content: data.content,
                pic_list: data.img,
            };
            this.btnDisabled = true;
            addComment(params).then((res) => {
                if (res.code === 200) {
                    this.$message.success('评论成功');
                    this.initData(this.searchForm.processState);
                }
                this.btnDisabled = false;
                this.handleClickCommentClose();
            });
        },
        // 再次提交
        handleClickAgainConfirm() {
            this.$router.push({
                name: "approveAdd",
                query: {
                    id: this.approvalDetailInfo.approval_set_id,
                    name: this.approvalDetailInfo.approval_set.name,
                    type: this.approvalDetailInfo.approval_type,
                    again_approval_id: this.approvalDetailInfo.approval_id,
                },
            });
        },
        // 修改
        handleClickEdit() {
            if(this.approvalDetailInfo.approval_type == ''){
                this.$router.push({
                    name: 'approveAdd',
                    query:{
                        id:this.approvalDetailInfo.approval_set_id,
                        name:this.approvalDetailInfo.approval_set?.name,
                        type: this.approvalDetailInfo.approval_type,
                        edit_approval_id: this.approvalDetailInfo.approval_id,
                    },
                    params: {
                        isPush: true
                    }
                })
            }else{
                this.$refs.relatedHandle.handleClickRelateHandle(this.approvalDetailInfo.approval_type,this.approvalDetailInfo,this.currentApproval.field_auth)
            }

        },
        // 关联功能操作完毕后回调
        relatedHandleSuccess(data){
            this.getApprovalDetail(data.approvalItem.approval_id,data.approvalItem)
        },

        // 一键已读
        handleClickMarkAllAsReadSubmit() {
            MarkAllAsRead().then((res) => {
                if (res.code === 200) {
                    if (res.code === 200) {
                        this.$message.success('操作成功');
                        this.initData(this.searchForm.processState);
                    }
                }
            });
        },
        // 点击每个审批
        handleClickApproveItem(item) {
            if (this.approvalId === item.approval_id) return false;
            this.approvalId = item.approval_id;
            this.getApprovalDetail(item.approval_id, item);
        },
        // 左侧分类筛选
        searchFilterChange() {
            this.initData(this.searchForm.processState);
        },
        // 初始化数据
        initData(state) {
            this.searchForm.approval_set_id = ''
            this.searchForm.processState = state || "awaiting_my_action";
            this.approval_tab_list.forEach((each) => (each.isPackUp = false));
            let item = this.approval_tab_list.find((item) => item.state == this.searchForm.processState);

            this.$set(item, "isPackUp", true);
            this.approvalPage = 1;
            this.formInfoList = [];
            this.formData = {};
            this.dataLoaded = false;
            this.currentUserApprovalPermission = {};
            this.getApprovalCenterTypeList(item);
            this.getApproveStateTypeNum();
        },
        // 获取审批状态
        getApprovalStatusText(approval_status) {
            let text = "";
            switch (approval_status) {
                case 0:
                    text = "审批中";
                    break;
                case 1:
                    text = "已通过";
                    break;
                case 2:
                    text = "已拒绝";
                    break;
                case 3:
                    text = "已撤销";
                    break;
            }
            return text;
        },
        // 获取所有审批类型
        getAllApprovalSetList() {
            AllApprovalSetList({keyword: ""}).then((res) => {
                if (res.code === 200) {
                    this.approvalSetTypeList = res.data || [];
                }
            });
        },

        // 审批分类列表
        getApprovalCenterTypeList(state) {
            this.approvalTypeListLoading = true;
            const params = {
                type: this.searchForm.processState,
                approval_set_id: this.searchFilterList[0].field_value,
                creator_uid: this.searchFilterList[1].field_value,
            };
            approvalCenterTypeList(params).then((res) => {
                if (res.code === 200) {
                    if (state) {
                        this.$set(state, "children", res.data || []);
                    }
                    this.approvalTypeListLoading = false
                    this.getApprovalCenterOverviewList();
                }
            });
        },
        // 审批概览区列表
        getApprovalCenterOverviewList() {
            this.approvalList = []
            this.approvalListLoading = true;
            this.approvalCenterLoading = true;
            approvalCenterOverviewList({
                keyword: this.searchForm.keyword,
                type: this.searchForm.processState,
                page: this.approvalPage,
                pageSize: 15,
                approval_set_id: this.searchForm.approval_set_id ? [this.searchForm.approval_set_id] : this.searchFilterList[0].field_value.length > 0 ? this.searchFilterList[0].field_value : [],
                creator_uid: this.searchFilterList[1].field_value,
                date_range: this.searchForm.list_update_date,
                sort_field: this.searchForm.sort_field,
                approval_status: this.searchForm.approve_status,
            }).then((res) => {
                if (res.code === 200) {
                    const {list, total} = res.data;
                    this.approvalList = list || [];
                    this.approvalListTotal = Number(total);
                    if (this.approvalList.length > 0) {
                        this.approvalId = this.approvalList[0].approval_id;
                        this.getApprovalDetail(this.approvalList[0].approval_id, this.approvalList[0]);
                    } else {
                        this.approvalDetailInfo = {};
                        this.approvalNodeList = [];
                    }
                }

                this.approvalListLoading = false;
                this.approvalCenterLoading = false;
                this.approvalPage = this.approvalPage + 1
            });
        },
        // 审批列表加载更多
        loadApprovalList() {
            if (this.approvalListLoading || this.approvalPage == 1 ||  this.approvalList.length == 0 || this.approvalList.length == this.approvalListTotal) {
                return false;
            }
            this.approvalListLoading = true;
            approvalCenterOverviewList({
                keyword: this.searchForm.keyword,
                type: this.searchForm.processState,
                page: this.approvalPage,
                pageSize: 15,
                approval_set_id: this.searchForm.approval_set_id ? [this.searchForm.approval_set_id] : this.searchFilterList[0].field_value.length > 0 ? this.searchFilterList[0].field_value : [],
                creator_uid: this.searchFilterList[1].field_value,
                date_range: this.searchForm.list_update_date,
                sort_field: this.searchForm.sort_field,
                approval_status: this.searchForm.approve_status,
            }).then((res) => {
                if (res.code === 200) {
                    const {list, total} = res.data;
                    this.approvalList = this.approvalList.concat(list || []);
                    this.approvalListTotal = Number(total);
                }
                this.approvalListLoading = false;
                this.approvalPage++;
            });
        },
        // 审批自定义字段数据
        getCustomFieldsData(field_list) {
            // 除了待我处理的审批用当前节点的权限 ，，别的分类的审批用 包含自己的最后一个节点的权限、
            let field_auth_hide = []
            if (this.searchForm.processState == 'awaiting_my_action') {
                // 字段权限隐藏
                field_auth_hide = this.currentApproval.field_auth.filter(find => find.field_auth == 3).map((item) => item.field_key) // 隐藏
            } else {
                let node_list = JSON.parse(JSON.stringify(this.approvalNodeList))
                node_list.forEach((item) => {
                    let ccUids = item.cc_info.map(map => map.cc_uid)
                    let approverUids = []
                    item.handle_info.forEach((each) => {
                        if (each.approver_info) {
                            approverUids.push(each.approver_info.id)
                        }  //审批人 -- 办理人
                        if (each.forward_info) {
                            approverUids.push(each.forward_info.id)
                        } //转交人 -- 加签人
                    })
                    this.$set(item, 'all_user_ids', [...new Set([...ccUids, ...approverUids])])
                })
                let filteredNodes = node_list.filter(node => node.all_user_ids.includes(this.owner_uid));
                let lastNode = filteredNodes[filteredNodes.length - 1]; //最后一个包含自己的节点
                if(!lastNode){ //如果节点中没有自己 就是开始
                    lastNode = node_list[0];
                }
                field_auth_hide = lastNode.field_auth.filter(find => find.field_auth == 3).map((item) => item.field_key) // 隐藏
            }
            // 字段权限隐藏
            field_list = field_list.filter(item => !field_auth_hide.includes(item.field_key));
            let data = {};
            field_list.forEach((item) => {
                data[item.field_key] = item.field_value;
            });
            return data;
        },
        // 审批详情
        getApprovalDetail(approval_id, approvalItem) {
            this.approvalDetailLoading = true;
            this.dataLoaded = false;
            approvalDetail({approval_id}).then((res) => {
                if (res.code === 200) {
                    this.approvalDetailInfo = res.data || {};
                    this.approvalNodeList = res.data.node_list || [];
                    this.approver_list = res.data.node_list.filter(item => item.type === 'approval').flatMap(node => node.handle_info.map(handle => handle.uid));
                    // 查找需要操作的流程节点
                    const node_item = this.approvalDetailInfo.node_list.find((item) => item.need_operation == 1);
                    let currentApproval = node_item || {};
                    // 判断handle_info中need_operation=1的用户和当前登录用户id一致
                    // 还需判断或签（任一一个人都可审批），还是会签还是依次审批
                    // if (node_item) {
                    //     if (node_item.approval_mode == 3) {
                    //         // 依次审批，依次审批只有一个
                    //         const currentNeedOperator = node_item.handle_info.find((item) => item.need_operation == 1);
                    //         currentApproval.active_user = currentNeedOperator
                    //             ? currentNeedOperator.uid == this.owner_uid
                    //             : false;
                    //     } else {
                    //         // 或签、会签
                    //         const currentNeedOperatorUIds = node_item.handle_info
                    //             .filter((item) => item.need_operation == 1)
                    //             .map((item) => item.uid);
                    //         currentApproval.active_user = currentNeedOperatorUIds.includes(this.owner_uid);
                    //     }
                    // } else {
                    //     currentApproval.active_user = false;
                    // }
                    // 判断是否有修改权限
                    if (this.approvalDetailInfo.creator_uid == this.owner_uid) {
                        currentApproval.edit_auth_tooltip = "当前审批无法修改，如需修改可以撤销后重新发起";
                    }else{
                        currentApproval.edit_auth_tooltip = "您没有对该审批单的修改权限";
                    }
                    this.currentApproval = currentApproval;
                    // 获取当前的审批流程中的用户
                    this.carbonCopyUserIds = Array.from(
                            new Set(this.approvalNodeList.flatMap((item) => item.handle_info.map((info) => info.uid || "")))
                    );

                    // 审批详情
                    if (this.approvalDetailInfo.approval_content && this.approvalDetailInfo.approval_content.content && this.approvalDetailInfo.approval_content.content.custom_details) {
                        this.formInfoList = JSON.parse(JSON.stringify(this.approvalDetailInfo.approval_content.content.custom_details));
                        this.formInfoList.forEach(field => {
                            if (field.field_type === 'table') {
                                field._child = field.table_title
                            }
                        });
                        this.formData = this.getCustomFieldsData(this.formInfoList);
                        this.dataLoaded = true;
                    }
                    if (this.approvalDetailInfo.approval_content && this.approvalDetailInfo.approval_content.content && this.approvalDetailInfo.approval_content.content.business_data) {
                        this.business_data = JSON.parse(JSON.stringify(this.approvalDetailInfo.approval_content.content.business_data))
                    }
                }
                if (approvalItem.is_read == 0) { //标记已读
                    this.setMakeAsRead(approval_id, approvalItem)
                }
                this.getCurrentUserApprovalPermission(approval_id);
                this.getCommentList();
                this.approvalDetailLoading = false;
            });
        },
        // 审批标记已读
        setMakeAsRead(approval_id, approvalItem) {
            MakeAsRead({approval_id}).then((res) => {
                if (res.code === 200) {
                    approvalItem.is_read = 1
                    this.getApproveStateTypeNum();
                }
            });
        },
        // 获取当前用户的审批权限按钮状态
        getCurrentUserApprovalPermission(approval_id) {
            GetCurrentUserApprovalPermission({approval_ids: [approval_id]}).then((res) => {
                if (res.code === 200) {
                    this.currentUserApprovalPermission = res.data && res.data.length ? res.data[0] : {};
                } else {
                    this.currentUserApprovalPermission = {};
                }
            });
        },
        // 获取人员
        getUserList(keyword) {
            GetUserList({keyword}).then((res) => {
                if (res.code == 200) {
                    this.userList = res.data || [];
                }
            });
        },
        // 获取评论列表
        getCommentList() {
            commentList({approval_id: this.approvalId}).then((res) => {
                if (res.code === 200) {
                    this.approveCommentList = res.data || [];
                }
            });
        },
        // 获取状态类型数量
        getApproveStateTypeNum() {
            let postData = {
                keyword: this.searchForm.keyword,
                approval_set_id: this.searchFilterList[0].field_value,
                creator_uid: this.searchFilterList[1].field_value,
                date_range: this.searchForm.list_update_date,
                approval_status: this.searchForm.approve_status,
            }
            ApprovalStateTypeNum(postData).then((res) => {
                if (res.code === 200) {
                    const data = res.data;
                    this.stateTypeNum.pending_num = data.pending_num;
                    this.stateTypeNum.received_num = data.received_num;
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/approval.scss";

.search_container {
    width: 100%;
    padding: 4px;
    box-sizing: border-box;

    .search_top_container {
        display: flex;
        justify-content: space-between;

        span.title {
            line-height: 24px;
            color: rgba(51, 51, 51, 1);
            font-size: 16px;
            font-weight: bold;
        }

        .el-button {
            padding: 5px 10px;
        }
    }

    .search_bottom_container {
        padding: 16px 0 0px;
        box-sizing: border-box;

        ul {
            width: 100%;

            li {
                width: 100%;
                display: flex;
                margin-bottom: 12px;

                & > div {
                    flex: 1;
                }

                .search_filter_type {
                    margin: 0 8px;
                    width: 86px;
                    max-width: 86px;
                }

                .el-date-editor.el-input {
                    width: 100%;
                    display: block;
                }
            }
        }
    }
}

.dropdown_icon {
    font-size: 14px;
    margin-right: 4px;
}

.approval_submit_form {
    padding: 4px 4px 0;
    box-sizing: border-box;

    .approval_submit_form_title {
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        color: rgba(51, 51, 51, 1);
        margin-bottom: 12px;
    }

    .approval_submit_form_wrap {
        width: 100%;

        .el-select {
            width: 100%;
        }

        .approval_submit_form_bt {
            padding: 16px 0 4px;
            line-height: 22px;
            color: rgba(51, 51, 51, 1);
            font-size: 14px;
        }
    }

    .approval_submit_form_btn {
        text-align: right;
        padding: 16px 0 0 0;
    }
}

.el-dropdown-menu__item.active {
    background: rgba(41, 144, 255, 0.16);
    color: rgb(41, 144, 255) !important;
}
</style>

